export function highestPriceUrl(value) {
  const url = new URL(value);
  if (!/\/(?:search|collections\/(?:vendors|types|all))\/?$/.test(url.pathname)) return null;
  if (url.searchParams.get('sort_by')) return null;
  url.searchParams.set('sort_by', 'price-descending');
  return url.toString();
}

if (typeof document !== 'undefined') {
  const destination = highestPriceUrl(location.href);
  if (destination) location.replace(destination);

  function setSearchDefaults() {
    for (const form of document.querySelectorAll('form[role="search"]')) {
      if (form.querySelector('[name="sort_by"]')) continue;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'sort_by';
      input.value = 'price-descending';
      form.append(input);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setSearchDefaults, { once: true });
  else setSearchDefaults();

  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
    if (!event.formData.get('sort_by')) event.formData.set('sort_by', 'price-descending');
  });
}
